<div class="position-relative"
    (click)="onClick()"
    [ngClass]="{'pointer': pointer}">
  <ng-container *ngIf="photo; else initialDisplay">
    <img [src]="(photo | secure | async) "
        class="display-profile"
        [style.width.px]="size"
        [style.height.px]="size"
        [ngClass]="{'border-0': !borderColor}"
        [style.border-color]="borderColor || ''">
  </ng-container>
  <ng-template #initialDisplay>
    <ng-container [ngSwitch]="!!defaultPhoto">
      <img *ngSwitchCase="true"
          class="display-profile"
          [src]="defaultPhoto"
          [style.border-radius]="'50%'"
          [style.width.px]="size"
          [style.height.px]="size"
          [ngClass]="{'border-0': !borderColor}"
          [style.border-color]="borderColor || ''">
      <div *ngSwitchDefault
          class="display-profile"
          [style.width.px]="size"
          [style.height.px]="size"
          [style.font-size.px]="fontSize || size * 0.5"
          [style.background]="colorProfile"
          [style.border-color]="borderColor || colorProfile">
        <span class="lh-normal">{{ initialName }}</span>
      </div>
    </ng-container>
  </ng-template>
</div>